import dayjs from 'dayjs';
import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
import type { GetArtistPageExhibitionsQuery } from '#lib/websites/artists/queries/__generated__/getArtistPageExhibitions.generated.js';
import type { MainCardProps } from '$global/components/MainCard';
import { getDirectusDateTimestamp } from '$global/utils/getDirectusDateTimestamp';
import { getImageUrl } from '$global/utils/getImageUrl';

export type ExhibitionMainCardProps = MainCardProps & {
	title: string;
	dataCy: string;
	src: string;
	subtitle: string;
	short_location_description: string;
	dates: string;
	description: string;
	startDate: string;
	startDateTimestamp: number;
	endDateTimestamp: number;
};

export const transformInfiniteDataExhibitions = (
	data: GetArtistPageExhibitionsQuery
) => {
	const artistExhibitions =
		data.Artists[0]?.exhibitions?.map(
			(exhibition) => exhibition?.Exhibitions_id
		) || [];

	const sanitisedExhibitions = artistExhibitions.map((exhibition) => {
		const dateRange = (() => {
			const startDateYear = dayjs(exhibition?.start_date).year();
			const endDateYear = dayjs(exhibition?.end_date).year();
			if (startDateYear === endDateYear) {
				return `${dayjs(exhibition?.start_date).format('DD MMM')} - ${dayjs(
					exhibition?.end_date
				).format('DD MMM YYYY')}`;
			}

			return `${dayjs(exhibition?.start_date).format('DD MMM YYYY')} - ${dayjs(
				exhibition?.end_date
			).format('DD MMM YYYY')}`;
		})();

		const artistNames =
			exhibition?.artists
				?.map((artist) => artist?.Artists_id?.name || '')
				.join(', ') || '';

		return {
			title: artistNames || '',
			dataCy: 'exhibitions-home',
			src: getImageUrl(exhibition?.featured_image?.filename_disk),
			subtitle: exhibition?.title || '',
			startDateTimestamp:
				getDirectusDateTimestamp(exhibition?.start_date) / 1000,
			endDateTimestamp: getDirectusDateTimestamp(exhibition?.end_date) / 1000,
			dates: dateRange,
			short_location_description: exhibition?.short_location_description || '',
			description: '',
			secondaryButtonProps: {
				label: 'More Info',
				href: `${GlobalRoutes.ExhibitionsHome}/${exhibition?.exhibition_page?.slug}`,
			},
			startDate: dayjs(exhibition?.start_date).format('DD MMM YYYY'),
		} as ExhibitionMainCardProps;
	});

	return sanitisedExhibitions;
};
